module.exports = __webpack_public_path__ + "img/caselist14.c92b3790.jpg";